import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  LoadboardListRequest,
  LoadboardListResponse,
  LoadboardRequest,
  LoadboardResponse,
} from './LoadboardService.types';
import { CredentialService } from './services/CredentialService';

export class LoadboardService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  credential: CredentialService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.credential = new CredentialService(instance);
  }

  // list instead of a search because it does not take any parameters
  list(_request: LoadboardListRequest) {
    return this.instance.get<LoadboardListResponse>('/loadboards');
  }

  search(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  create(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(request: LoadboardRequest) {
    return this.instance.get<LoadboardResponse>(`/loadboards/${request.routeParams.id}`);
  }

  update(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }
}
